/* eslint-disable @typescript-eslint/no-explicit-any */
export const findNestedValue = (path: string, data: any) => {
  const found = path.split('.').reduce((previous, current) => {
    if (!previous || !Object.hasOwn(previous, current)) {
      return undefined;
    }

    return previous[current];
  }, data);

  return found;
};
/* eslint-enable @typescript-eslint/no-explicit-any */
